var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col gap-5 px-4 w-screen lg:w-176" },
    [
      _c(
        "div",
        {
          staticClass:
            "reltive flex flex-col gap-2 rounded bg-pure-white p-4 lg:p-5"
        },
        [
          _c("div", [_c("BlTextTitle4", { attrs: { text: "Comments" } })], 1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center gap-2 flex-wrap" },
            _vm._l(_vm.filterOptions, function(opt) {
              return _c(
                "div",
                {
                  key: opt.label,
                  staticClass:
                    "h-7.5 px-2 flex items-center rounded-full cursor-pointer flex-shrink-0",
                  class: [
                    opt.value === _vm.filterInput
                      ? "bg-light-purple"
                      : "bg-slate-200 hover:bg-hover-state"
                  ],
                  on: {
                    click: function($event) {
                      return _vm.onFilter(opt.value)
                    }
                  }
                },
                [
                  _c("BlTextBody2", {
                    class: [
                      opt.value === _vm.filterInput
                        ? "text-pure-white"
                        : "text-slate-800"
                    ],
                    attrs: { text: opt.label }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _vm.fetchLoading
        ? _c("div", { staticClass: "h-100 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !(_vm.sessionComments || []).length
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col gap-4 rounded bg-pure-white p-4 lg:p-5 items-center"
            },
            [_c("BlTextBody2", { attrs: { text: "Comment(s) not found." } })],
            1
          )
        : _vm._l(_vm.sessionComments, function(comment, idx) {
            return _c("SessionComment", {
              key: idx,
              attrs: { comment: comment, disabledAction: _vm.disabledAction },
              on: { "on-filter": _vm.onFilter }
            })
          }),
      _vm._v(" "),
      !_vm.fetchLoading && _vm.filterInput !== "target" && !_vm.disabledAction
        ? _c("div", [
            !_vm.newOpened
              ? _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center rounded bg-pure-white p-2 hover:bg-hover-state cursor-pointer",
                    on: { click: _vm.openNew }
                  },
                  [
                    _c("BlTextSubtitle3", {
                      staticClass:
                        "text-light-purple hover:text-dark-purple-200",
                      attrs: { text: "Add new comment" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col gap-4 rounded bg-pure-white p-4 lg:p-5"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      _vm._l(_vm.typeOptions, function(opt) {
                        return _c(
                          "div",
                          {
                            key: opt.label,
                            staticClass:
                              "h-7.5 px-2 flex items-center rounded-full cursor-pointer",
                            class: [
                              opt.value === _vm.typeInput
                                ? "bg-light-purple"
                                : "bg-slate-200 hover:bg-hover-state"
                            ],
                            on: {
                              click: function($event) {
                                return _vm.onChangeType(opt.value)
                              }
                            }
                          },
                          [
                            _c("BlTextBody2", {
                              class: [
                                opt.value === _vm.typeInput
                                  ? "text-pure-white"
                                  : "text-slate-800"
                              ],
                              attrs: { text: opt.label }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.typeInput === "general"
                      ? _c("BlInputText", {
                          attrs: { input: _vm.bodyInput },
                          on: { changed: _vm.inputHandler }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeInput === "assessment"
                      ? _c(
                          "div",
                          { staticClass: "flex flex-col gap-4" },
                          [
                            _c("BlInputText", {
                              attrs: { input: _vm.antecedentInput },
                              on: { changed: _vm.inputHandler }
                            }),
                            _vm._v(" "),
                            _c("BlInputText", {
                              attrs: { input: _vm.behaviorInput },
                              on: { changed: _vm.inputHandler }
                            }),
                            _vm._v(" "),
                            _c("BlInputText", {
                              attrs: { input: _vm.consequenceInput },
                              on: { changed: _vm.inputHandler }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "pt-2 flex items-center justify-end gap-2 border-t border-slate-400"
                      },
                      [
                        _c("BlInputButton", {
                          attrs: {
                            type: "outlined",
                            dense: "",
                            label: "Cancel"
                          },
                          on: {
                            clicked: function($event) {
                              _vm.newOpened = false
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.typeInput === "general"
                          ? _c("BlInputButton", {
                              attrs: {
                                label: "Add comment",
                                icon: "plus",
                                dense: "",
                                disabled: _vm.isDisabledSubmit,
                                loading: _vm.newLoading
                              },
                              on: { clicked: _vm.onCreate }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.typeInput === "assessment"
                          ? _c("BlInputButton", {
                              attrs: {
                                label: "Add ABC data",
                                icon: "plus",
                                dense: "",
                                disabled: _vm.isDisabledSubmit,
                                loading: _vm.newLoading
                              },
                              on: { clicked: _vm.onCreateABC }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "h-6 flex-shrink-0" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f175b87", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f175b87","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/comment/RecordComments.vue
// module id = null
// module chunks = 